import 'mathlive';
// NOTE: for some reason, the above import is needed to make the math-field element work
// and the import below is needed to make the MathfieldElement type work
// eslint-disable-next-line no-duplicate-imports
import type { MathfieldElement } from 'mathlive';
import { useEffect } from 'react';

// Declare the math-field element
// This allows us to use the math-field element in the JSX
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'math-field': React.DetailedHTMLProps<
        React.HTMLAttributes<MathfieldElement>,
        MathfieldElement
      >;
    }
  }
}

export interface MathFieldEditorProps {
  initialValue: string;
  onChange: (value: string) => void;
}

export default function MathFieldEditor(props: Readonly<MathFieldEditorProps>) {
  const { initialValue, onChange } = props;
  useEffect(() => {
    // NOTE: set keyboard z-index to make it above MUI's dialog
    document.body.style.setProperty('--keyboard-zindex', Number.MAX_SAFE_INTEGER.toString());
  }, []);

  return (
    <math-field
      style={{ minWidth: '100%' }}
      onInput={(event: React.ChangeEvent<MathfieldElement>) => {
        onChange(event.target.value);
      }}
    >
      {initialValue}
    </math-field>
  );
}
